import React, { useState, useEffect } from "react";
import axios from "axios";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import Rejected from "../../../assets/Icon/Rejected.png";
import PromoFile from "./PromoFile";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";
const RejectedPromoVideo = () => {
  const [buffer, setLoading] = useState(true);
  const [event, setEvents] = useState([]);
  const [reject, setReject] = useState("");

  // Fetch Rejected LiveChat
  useEffect(() => {
    axios.get(`/api/star/promoVideoReject`).then((res) => {
      if (res.data.status === 200) {
        setEvents(res.data.promoVideos);
        setReject(res.data.rejectTotal);
      }
      setLoading(false);
    });
  }, []);

  return (
    <>
      <>
        <AllDataHeader
          title={"Rejected Promo Video"}
          image={Rejected}
          count={reject}
        />
        {buffer ? <LoaderPost /> : <PromoFile data={event} />}
      </>
    </>
  );
};

export default RejectedPromoVideo;
